<template>
    <div class="faq">
        <van-nav-bar v-if="$route.query.isApp != 1" class="apiHeader" :title="$t('300270')" left-arrow @click-left="$router.go(-1)" />
        <div class="apiBody">
            <div class="commont_body">
                <van-collapse v-model="activeNames" :border="false">
                    <!-- 如何在 SuperEx 创建 API Key？ -->
                    <van-collapse-item :title="'1. ' + $t('9100117')" name="1">

                        <span>
                            {{ $t("9100122") }}
                        </span>
                    </van-collapse-item>
                    <!-- SuperEx 的 API 文档在哪里可以查看？ -->
                    <van-collapse-item :title="'2. ' + $t('9100118')" name="2">
                        <p v-html="$t('9100123')"></p>
                    </van-collapse-item>
                    <van-collapse-item :title="'3. ' + $t('9100119')" name="3">
                        <p v-html="$t('9100124')"></p>
                    </van-collapse-item>
                    <van-collapse-item :title="'4. ' + $t('9100120')" name="4">
                        <p v-html="$t('9100125')"></p>
                    </van-collapse-item>
                </van-collapse>
            </div>
        </div>
    </div>
</template>

<script>
    import { List, Icon, NavBar, Button, Collapse, CollapseItem } from "vant";
    import { setToken, getCookie, removeToken, setCookie } from '../../utils/auth'
    import { parseTime } from "@/utils/index";
    import { getListdata } from "@/api/resource";
    import { Empty } from "vant";
    import { mapGetters } from "vuex";

    export default {
        name: "apiKey",
        components: {
            vanList: List,
            vanIcon: Icon,
            vanEmpty: Empty,
            vanNavBar: NavBar,
            Button,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem
        },
        data() {
            return {
                activeNames: ["0"]
            };
        },
        watch: {
            $route() {
                this.resher()
            },
        },
        computed: {
            ...mapGetters(["isDirection"])
        },
        created() {
            this.resher()
        },
        methods: {
            resher() {
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                if (token) {
                    setToken(token);
                    this.$store.dispatch('GetInfo', token);
                    this.$store.dispatch('setToken', token);
                }
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != '') {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        this.$route.query.backgroundColor === 'day'
                            ? 'sunlight'
                            : 'moon'
                    )
                } else {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        'moon'
                    )
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/css/variableName";
    @import "../../style/mixin";
    @import "../../assets/css/mixin";

    .faq {
        @include background_color("background-color-2");
        // width: 100%;
        // height: 100vh;
        // overflow: hidden;
        position: fixed;
        width: 100vw;
        min-height: 100vh;
        top: 0;
        left: 0;
        /deep/ .van-nav-bar .van-icon {
            // color: #000 !important;
            @include font_color("font-color");
        }
        /deep/ .van-nav-bar .van-nav-bar__content {
            @include background_color("background-color-2");
        }

        /deep/ .van-nav-bar .van-nav-bar__title {
            @include font_color("font-color");
        }
        /deep/ .van-cell {
            @include background_color("background-color-2");
            @include font_color("font-color");

            /deep/ .van-cell__title {
                @include font_color("font-color");
                font-weight: bold !important;
                font-size: torem(14);
                span {
                    font-weight: bold !important;
                }
            }
        }
        /deep/ .van-hairline--bottom::after{
            @include border_color("border-color-6");
        }
        .apiBody {
            height: 100vh;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            // .commont_body {
            //     .van-collapse {
            //         /deep/ .van-collapse-item__content {
            //             @include background_color("background-color-6");
            //         }
            //     }
            // }
                        .commont_body {
                .van-collapse {
                    /deep/ .van-collapse-item__content {
                        @include background_color("background-color-6");
                    }

                    /deep/ .van-collapse-item--border::after {
                        @include border_color("border-color-1");
                    }
                    /deep/ .van-cell::after{
                        border: none;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/apiKey/FAQ.vue